import { effect, inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

import { allBadge, isLoading, isUnreadOnly } from '@features/notifications/store/services/notification.store';
import { NotificationsApiService } from '@features/notifications/store/services/notifications-api.service';
import { NotificationsService } from './notifications.service';

@Injectable({ providedIn: 'root' })
export class NotificationBellService {
    public readonly badge$ = new BehaviorSubject<number>(0);
    public readonly isShowingNotificationBell$ = new Subject<boolean>();

    private readonly notificationsService = inject(NotificationsService);
    private readonly notificationsApiService = inject(NotificationsApiService);

    constructor() {
        effect(() => {
            this.badge$.next(allBadge());
        });
    }

    public open(): void {
        this.notificationsApiService.loadNotifications();
        this.isShowingNotificationBell$.next(true);
    }

    public close(): void {
        this.isShowingNotificationBell$.next(false);
        this.notificationsService.resetCollapsed();
    }

    public toggleUnread(): void {
        isLoading.set(true);
        isUnreadOnly.set(!isUnreadOnly());
        this.notificationsApiService.loadNotifications();
    }
}
